// 元数据时间格式化  completionDate:1补全时间格式
export function metadataDateFormatValue(date, format, completionDate) {
    if(!date) {
        return
    }
    if(!format) {
        return date
    }
    if(format == 'yyyy') {
        return completionDate ? date.split('-')[0] +  '-01-01' : date.split('-')[0]
    }
    if(format == 'yyyy-MM') {
        let arr = date.split('-')
        return completionDate ? arr[0] + '-' + arr[1] + '-01' : arr[0] + '-' + arr[1]
    }
    if(format == 'yyyy/MM/dd') {
        let arr = date.split(' ')[0].split('-')
        return arr[0] + '/' + arr[1] + '/' + arr[2]
    }
    if(format == 'yyyy-MM-dd') {
        return date.split(' ')[0]
    }
    if(format == 'HH:mm:ss') {
        return  completionDate ? '2024-01-01 ' + date.split(' ')[1] : date.split(' ')[1]
    }
    return date
}

// 表单校验（数据规则）
export function validatorDataRule(data) {
    return {
        validator: (rule, value, callback) => {
            if (!data.metadataBasicDataRuleVo || !value) {
                callback()
            } else {
                let {ruleDecimal, ruleMin, ruleMax, ruleDateFormat, ruleDateType, ruleDateStart, ruleDateEnd} = data.metadataBasicDataRuleVo
                // 单行文本、多行文本
                if((data.basicAssemblyId == '1' || data.basicAssemblyId == '2') && ruleMin && value.length < ruleMin * 1) {
                    callback(new Error('字符长度必须大于或等于' + ruleMin));
                } else if (data.basicAssemblyId == '8' || data.basicAssemblyId == '9') {
                    let type = data.basicAssemblyId == '8' ? '时间' : '日期'
                    let dateStartTips = metadataDateFormatValue(ruleDateStart, ruleDateFormat)
                    let dateEndTips = metadataDateFormatValue(ruleDateEnd, ruleDateFormat)
                    let date = metadataDateFormatValue(value, ruleDateFormat)
                    let start = dateStartTips, end = dateEndTips
                    if(ruleDateFormat == 'yyyy-MM' || ruleDateFormat == 'yyyy' || ruleDateFormat == 'HH:mm:ss') {
                        date = metadataDateFormatValue(value, ruleDateFormat, 1)
                        start = metadataDateFormatValue(ruleDateStart, ruleDateFormat, 1)
                        end = metadataDateFormatValue(ruleDateEnd, ruleDateFormat, 1)
                    }
                    // ruleDateType 0不得大于当前；1不得小于当前；2区间手动设置
                    if (ruleDateType == '0' && new Date(date) > new Date()) {
                        callback(new Error('不得大于当前' + type))
                    } else if (ruleDateType == '1' && new Date(date) < new Date()) {
                        callback(new Error('不得小于当前' + type))
                    } else if (ruleDateType == '2' && !(new Date(date) >= new Date(start) && new Date(date) <= new Date(end))) {
                        callback(new Error('请选择'+ dateStartTips + "至" + dateEndTips+'范围内的' + type))
                    }
                    callback()
                } else if (data.basicAssemblyId == '12') {
                    let x = String(value).indexOf('.') + 1;   //小数点的位置
                    let y = String(value).length - x;  //小数的位数
                    if (!/^-?(0|([1-9][0-9]*))(\.[\d]+)?$/.test(value)) {
                        callback(new Error('请输入正确的数值'))
                    } else if (ruleDecimal && x > 0 && y > ruleDecimal) {
                        callback(new Error('最多保留' + ruleDecimal + '位小数'))
                    } else if (ruleMin && value < ruleMin*1) {
                        callback(new Error('数值必须大于或等于'+ ruleMin))
                    } else if (ruleMax && value > ruleMax*1) {
                        callback(new Error('数值必须小于或等于'+ ruleMax))
                    } else if (value > 99999999) {
                        callback(new Error('数值必须小于或等于99999999'))
                    }
                    callback()
                } else {
                    callback()
                }
                callback()
            }
        },
        trigger: 'change'
    }
}

// 设置日期组件选择器类型
export function setDatePickerType(item, range) {
    let format = item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.ruleDateFormat ? item.metadataBasicDataRuleVo.ruleDateFormat : ''
    let type = 'datetime'
    if(format) {
        type = this.$dictUtils.getDictLabel("datePickerType", format ,'')
    }
    if(range) {
        return type+'range'
    } else {
        return type
    }
}

// 列表数据格式化
export function listDataFormat(item, val) {
    let v = val
    if(item.basicAssemblyId == '10') {
        v = this.$dictUtils.getDictLabel("metadata_switch", val ,'')
    } else if(Array.isArray(val)) {
        v = val.join('；')
    } else if(item.basicAssemblyId == '8' && val) {
        v = val.indexOf(" ") > -1 ? val.split(" ")[1] : val
    } else if(item.basicAssemblyId == '9' && val) {
        let format = item.metadataBasicDataRuleVo && item.metadataBasicDataRuleVo.ruleDateFormat ? item.metadataBasicDataRuleVo.ruleDateFormat : ''
        v = this.metadataDateFormatValue(val, format)
    }
    return v
}

export default {
    metadataDateFormatValue,
    validatorDataRule,
    setDatePickerType,
    listDataFormat
}

